// extracted by mini-css-extract-plugin
export var indeterminate = "_53-6";
export var md = "_53-5";
export var semantic = "_53-7";
export var sm = "_53-4";
export var text = "_53-8";
export var toggleControl = "_53-0";
export var toggleInput = "_53-1";
export var toggleSwitch = "_53-2";
export var xs = "_53-3";